import styled, { css } from 'styled-components';
import { devices } from '../../../juristec-ui/core/breakpoints';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

export const HeaderContainer = styled.div`
  display: flex;
  padding: 5px 0 0 5px;
  width: 100%;
  align-items: center;
  & h2 {
    margin: 0 auto;
    color: ${({ theme }) => theme.primary};
    @media ${devices.phoneS} {
      font-size: 20px;
    }
  };
`;

export const SubHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  border: solid #ddd;
  border-width: 1.6px 0 0 0;
  margin: 5px 0 0 0;
  padding: 5px 10px;
  & > div {
    margin-right: 10px;
  }
  & h5 {
    margin: 0;
    font-size: 16px;
  }
`;

export const EmptyMsg = styled.span`
  text-align: center;
  margin: 10px 0;
  font-size: 12px;
  color: ${({ theme }) => theme.grey};
`;

export const ActionFooter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px 10px;
  & .token-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
  & .gen-button-tooltip {
    margin-top: 5px;
    width: 100%;
  }
`;

export const TimelineContainer = styled.div`
  /* height: calc(100vh - 130px); */
  flex: 1;
  width: 100%;
  padding: 0;
  overflow: hidden auto;
`;

export const TimelineTimestamps = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 5px;
  margin: 5px 10px;
  box-sizing: border-box;
  border-radius: 8px;
  cursor: pointer;
  position: relative;
  background-color: ${({ theme }) => theme.container};
  border: 2px solid transparent;
  &:nth-child(odd) {
    background-color: ${({ theme }) => theme.containerOdd};
  }
  &:last-child {
    border-color: ${({ theme }) => theme.info};
  }
  & > span {
    margin: auto;
  }
  & > svg {
    margin: 0;
    transform: rotate(270deg);
    width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    fill: ${({ theme }) => theme.toolbarFont};
  }
  &:hover {
    background-color: ${({ theme }) => theme.containerHover};
  }
`;

interface MsgContainerProps {
  msgType?: string;
  theme: Record<string, string>;
}

const getMsgColors = (theme: Record<string, string>, msgType?: string) => {
  if (msgType === 'kpi') return theme.bubbleAnswer;
  if (msgType === 'general') return theme.bubbleQuestion;
  if (msgType === 'error') return theme.bubbleError;
  return theme.container;
};

export const MsgContainer = styled.div<MsgContainerProps>`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme, msgType }) => getMsgColors(theme, msgType)};
  border-radius: 8px;
  padding: 0;
  position: relative;
  min-height: 0;
  cursor: ${({ msgType }) => (msgType === 'kpi' ? 'pointer' : 'default')};
  max-width: 100%;
  min-width: 0;
  & p {
    margin: 5px 10px;
    font-size: 14px;
    white-space: pre-wrap;
  }
  & > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin: 0 10px 2px 10px;
    & span {
      margin: 0;
      font-size: 12px;
      color: ${({ theme }) => theme.color}88;
    }
    & svg {
      margin: 0 0 0 auto;
      width: 15px;
      display: flex;
      align-items: center;
      justify-content: center;
      fill: ${({ theme }) => theme.color}88;
    }
    & h5 {
      margin: 0 auto 0 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    &:first-of-type {
      margin: 2px 10px 0 10px;
    }
  }
  & > button {
    margin: auto;
    width: 100%;
    &:hover {
      box-shadow: none;
    }
    & svg {
      margin: 0 0 0 10px;
    }
  }
  &:before {
    content: '';
    position: absolute;
    border: 16px solid;
    border-color: transparent ${({ theme, msgType }) => getMsgColors(theme, msgType)};
    top: 5px;
    border-top-width: 0;
  }
  ${({ theme, msgType }) => msgType === 'kpi' && css`
    &:hover {
      color: ${theme.color}88;
      & > div.footer span, & > div.footer svg {
        fill: ${theme.color};
        color: ${theme.color};
      }
    }
  `}
`;

export const Separator = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  margin: 0 10px;
  & h5 {
    margin: 0;
    position: absolute;
    right: 0px;
    background-color: ${({ theme }) => theme.sideMenu};
    color: ${({ theme }) => theme.grey};
    padding: 0 0 0 2px;
  }
  & hr {
    width: 100%;
    border: 0.8px solid ${({ theme }) => theme.grey};
  }
`;

export const MsgRow = styled.div`
  display: flex;
  padding: 10px;
  max-width: 100%;
  flex-direction: row;
  margin-right: auto;
  ${MsgContainer} {
    margin-left: 15px;
    &:before {
      border-left-color: transparent;
      border-left: 0;
      left: -15px;
    }
  }
`;

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-width: 50px;
  & > div {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const GPTCredits = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.grey};
  margin: 4px 2px 1px;
  & a {
    color: ${({ theme }) => theme.grey};
  }
  @media ${devices.phoneS} {
    font-size: 9px;
  }
`;
